class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    // Debounce function
    const debounce = (func, delay) => {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
      };
    };

    // Debounced click handler
    const debouncedClick = debounce((event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      this.fcfsToken = this.querySelector('[data-fcfs]')?.dataset.token;

      cartItems.updateQuantity(this.dataset.index, 0, undefined, this.fcfsToken);

      // For fcfs --- to enable the add to cart button after it's been removed from the cart
      if (document.querySelector("[data-fcfs='true']") || sessionStorage.getItem("Added") == "true") {
        sessionStorage.setItem("Added", false)
        let addtocartBtn = document.querySelector(".product-form__submit");
        let btnText = document.querySelector(".product-form__submit span");
        let recaptcha = document.querySelector(".recaptcha");

        if (sessionStorage.getItem("Added") == "false") {
          addtocartBtn.removeAttribute("disabled");
          addtocartBtn.removeAttribute("data-added");
          btnText.textContent = "Add to cart";
          recaptcha.style.display = "block"
        }
      }
    }, 1200); // Adjust delay as per your requirement

    // Add debounced click event listener
    this.addEventListener('click', debouncedClick);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    // showing loading indicator when cart changes
    const cartItem = event.target.closest('.cart-items');
    cartItem?.classList.add('is-loading');
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, fcfsToken) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        //Deleting the FCFS product session
        this.deleteFCFSProductSession(fcfsToken)

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading();

        setTimeout(() => {
          //for cart related products
          if (document.querySelector("cart-upsell-recommendations")?.innerHTML != "") {

            var elem = document.querySelector('cart-upsell-recommendations');
            document.querySelector(".shimmer-upsell-card-main").classList.add("cart-item-hidden");
            if (elem) {
              elem.classList.add("cart-item-visible");      
            var flkty = new Flickity(elem, {
              // options
              cellAlign: 'left',
              prevNextButtons: true,
              cellSpacing: 20,
              pageDots: false
            });
          }  }
        }, "1500");


      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  deleteFCFSProductSession(fcfsToken) {
    if (!fcfsToken) return;

    localStorage.removeItem("EndTimeCheckout")
    localStorage.removeItem("endTime");
    const deleteSessionURL = 'https://fcfs-stage.marmeto.com/api/delete/session';
    const data = {
      token: fcfsToken
    };

    fetch(deleteSessionURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      if (!quantityElement) return;

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

// cart drawer timer for only FCFS PRODUCTS

document.addEventListener('DOMContentLoaded', function () {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement('input');
  cartSubmitInput.setAttribute('name', 'checkout');
  cartSubmitInput.setAttribute('type', 'hidden');
  document.querySelector('#cart').appendChild(cartSubmitInput);
  document.querySelector('#checkout').addEventListener('click', function (event) {
    document.querySelector('#cart').submit();
  });
});

class MmTimer extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const endTime = localStorage.getItem('endTime');

    if (endTime) {
      // If end time exists in local storage, calculate the remaining time
      const now = new Date().getTime();
      const timeRemaining = Math.max(endTime - now, 0);
      _this.startTimer(timeRemaining);
    } else {
      // If end time doesn't exist in local storage, set the end time as 5 minutes from now
      const endTime = new Date().getTime() + 5 * 60 * 1000;
      localStorage.setItem('endTime', endTime);
      _this.startTimer(5 * 60 * 1000); // Start the timer with the initial 5 minutes
    }
  }

  startTimer(time) {
    const _this = this;
    const endTime = new Date().getTime() + time;
    localStorage.setItem('endTime', endTime);
    let timerInterval = setInterval(function () {
      let now = new Date().getTime();
      let timeRemaining = Math.max(endTime - now, 0);
      let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
      seconds = seconds < 10 ? '0' + seconds : seconds;
      _this.updateTimer(days, hours, minutes, seconds);
      if (!timeRemaining || timeRemaining < 0) {
        clearInterval(timerInterval);
        localStorage.removeItem('endTime');
        document.querySelector('.fcfs-timer-cart').textContent = ' ';
        document.querySelector('.fcfs-timer-cart').classList.remove('fcfs_timer-background');
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            for (let i = 0; i < cart.items.length; i++) {
              let fcfsProduct = cart.items[i].properties.fcfs;
              if (fcfsProduct == 'true') {
                document.querySelectorAll('cart-remove-button').forEach((elem) => {
                  if (elem.querySelector('[data-fcfs]')) elem.click();
                });
              }
            }
          });
      }
    }, 1000);
  }

  updateTimer(days, hours, minutes, seconds) {
    this.querySelector('.fcfs-timer-cart').classList.add('fcfs_timer-background');
    this.querySelector('.mins').innerHTML = minutes + 'm ';
    this.querySelector('.secs').innerHTML = seconds + 's ';
  }
}

customElements.define('mm-timer', MmTimer);




class CustomUpsellPopup extends HTMLElement {
  constructor() {
    super()
    const cartUpsellClose = this.querySelector('.cart-upsell-close');
    const cartUpsellArrowIcon = this.querySelector('.cart-recommended-arrow');
    const upsellCard = this.querySelector('.cart-upsell-main-container');

    if (cartUpsellClose && upsellCard) {
      cartUpsellClose.addEventListener('click', () => {
        upsellCard.classList.add('hidden');
        cartUpsellClose.classList.add('hidden');
        cartUpsellArrowIcon.classList.remove('hidden')
      });
    }
    if (cartUpsellArrowIcon) {
      cartUpsellArrowIcon.addEventListener('click', () => {
        upsellCard.classList.remove('hidden');
        cartUpsellClose.classList.remove('hidden');
        cartUpsellArrowIcon.classList.add('hidden');
        // const customEvent = new Event('cart-sell');
        // document.dispatchEvent(customEvent);
      })
    }
  }
}

// Define the custom element tag
customElements.define('custom-upsell-popup', CustomUpsellPopup);









